var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimecampLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3571 8.74094C16.3336 9.15979 16.1512 9.55436 15.8393 9.83359L11.7617 13.5C11.4793 13.755 11.1204 13.8946 10.7438 13.8885C10.7261 13.8885 10.7085 13.8885 10.6908 13.8885L10.5378 13.8764C10.2378 13.8339 9.95533 13.6943 9.73174 13.4818L7.37225 11.2722C6.78973 10.732 6.6544 9.87608 7.03686 9.23263C7.48993 8.48599 8.43726 8.2614 9.16099 8.7288C9.23748 8.77737 9.30809 8.83807 9.3787 8.89877L10.1672 9.63327C10.5143 9.96106 11.0439 9.96713 11.3969 9.64541L13.7799 7.50262C14.2507 7.0777 14.892 6.96237 15.4216 7.1991C16.0217 7.45405 16.3924 8.07322 16.3571 8.74094Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82596 21.3603C2.18319 19.7882 -1.15893 13.809 0.370916 8.02403C1.90076 2.2391 7.74359 -1.19059 13.3864 0.381602C14.2219 0.612271 14.7161 1.49853 14.4984 2.3605C14.2748 3.22247 13.4158 3.73237 12.5802 3.50777C12.5744 3.50777 12.5685 3.5017 12.5626 3.5017C8.59677 2.39692 4.49561 4.80681 3.41884 8.87387C2.34206 12.9409 4.68978 17.1415 8.65561 18.2463C12.6214 19.345 16.7226 16.9351 17.7994 12.8742C18.0288 12.0061 18.8997 11.5023 19.7352 11.739C20.5649 11.9758 21.0591 12.862 20.8414 13.7179C19.3116 19.5029 13.4746 22.9325 7.82596 21.3603Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimecampLogoWhite);
export default __webpack_public_path__ + "static/media/timecamp-logo-white.f435bdabfde4e1e1feaf02572fae7c27.svg";
export { ForwardRef as ReactComponent };